import AppointmentListResourceModel from '../../generated/types/model/resource/AppointmentListResourceModel';
import ISchedulerListEntry from '../interfaces/ISchedulerListEntry';
import BaseSchedulerListEntryMixin from '../mixin/BaseSchedulerListEntryMixin';

export default class AppointmentListResourceViewModel extends BaseSchedulerListEntryMixin(AppointmentListResourceModel) implements ISchedulerListEntry {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
